import React from 'react';

interface EmptyStateViewProps {
    message?: string;
}

/**
 * Component displayed when there's no state to show or an error occurs
 * @param props - Component props
 * @returns Rendered component
 */
const EmptyStateView: React.FC<EmptyStateViewProps> = ({
    message = 'No state available to view',
}) => {
    return (
        <div className="flex size-full items-center justify-center p-4">
            <div className="rounded-sm bg-gray-100 p-4 text-center text-gray-500">
                <div className="mb-2 text-3xl">🔍</div>
                <div>{message}</div>
            </div>
        </div>
    );
};

export default EmptyStateView;
